<template>
  <div class="pay" v-loading="loading">
      <div class="top">
          <div class="top_left">
              <div class="icon"></div>
              <div class="game_name">{{storage.appName}}</div>
              <div class="game_name_line">{{$t('title')}}</div>
          </div>
          <div class="top_center">
              <div class="uname">{{storage.roleName}}</div>
              <div v-if="storage.serverName" class="server_name">({{storage.serverName}})</div>
          </div>
          <div class="top_right">
              <!-- <div class="point">
                  <span class="point_num">9910.<em>01</em>礼金</span>
                  <span class="detail"></span>
              </div> -->
              <div class="user" @click="popCtrl"></div>
              <div class="close" @click="pageClose"></div>
              <div class="pop_down" v-if="popShow">
                <div class="down_li" @click="dialogCtrl('record')">{{$t('consumeRecord')}}</div>
              </div>
          </div>
      </div>
      <div class="content" v-if="allGearLoading == 'loaded'">
          <div class="content_left">
              <div class="back_to_store" @click="backToStore">{{$t('backToStore')}}</div>
          </div>
          <div class="content_center half_center">
              <div class="title">{{$t('checkout')}}</div>
              <div class="pay_total">
                  <div class="pay_name">{{buyList.length > 1 ? $t('multiName') : buyList[0].iapName}}</div>
                  <div class="pay_line"></div>
                  <div class="pay_count">{{(payment.currency && allGearData.currencyList.filter(v => v.currency == payment.currency)[0].currencyMark) || allGearData.currencyList.filter(v => v.currency == currency)[0].currencyMark}} {{(totalCount/100).toFixed(2)}}</div>
              </div>
              <div class="channel_title">{{$t('payTypeSelect')}}</div>
              <div class="channel_box" v-if="pcPmLoading">
                  <div class="channel" v-for="(item, key) of pcPmData.paymentList" :key="key" :class="{'channel_disable': !item.availableStatus, 'channel_hover': item.payModeId == activeTab}" @click="changePayment(item)">
                      <div>{{item.payModeName}}</div>
                      <div v-if="(item.limitAmount == 1) && !item.availableStatus" style="font-size:14px;line-height:30px">{{$t('unMinLimit')}}</div>
                      <div v-if="(item.limitAmount == 2) && !item.availableStatus" style="font-size:14px;line-height:30px">{{$t('unMaxLimit')}}</div>
                  </div>
              </div>
              <div class="submit" :class="{'submit_disable': !payment.currency}" @click="payHandle">{{$t('toPay')}}</div>
          </div>
          <div class="content_right">
              <div class="clear">{{$t('selectedGoods')}}</div>
              <div class="buy_list_box">
                <div class="buy_list" v-for="(item, key) of buyList" :key="key">
                    <div class="list_name">{{item.iapName}}</div>
                    <div class="list_limit">
                        <span v-if="item.limitNum">{{$t('left')}} {{item.limitNum}}/{{item.boughtNum + item.limitNum}}</span>
                        <span v-if="item.endTs > 0">{{$t('leftTime')}} {{formatDate((item.endTs + item.timeZone.split(':')[0].substr(3, 5) * 3600 + new Date().getTimezoneOffset() * 60) * 1000)}}</span>
                        <div style="clear:both"></div>
                    </div>
                    <div class="list_point">{{((payment.currency && allGearData.currencyList.filter(v => v.currency == payment.currency)[0].currencyMark) || allGearData.currencyList.filter(v => v.currency == currency)[0].currencyMark) + '  ' + (mustInteger ? Math.ceil(pcgData[item.price]) : pcgData[item.price])}}</div>
                    <div class="item_count">
                        <el-input-number size="mini" v-model="item.amount" :controls=false :disabled="true"></el-input-number>
                    </div>
                    <div style="clear:both"></div>
                </div>
              </div>
          </div>
      </div>
      <div class="pop_down_pop" v-if="popShow" @click="popShow = false"></div>
      <div class="dialog_pop" v-if="dialogShow" @click="dialogShow = false"></div>
      <div class="dialog" v-if="dialogShow" v-loading.body="orderLoad">
        <el-collapse v-infinite-scroll="orderScroll">
            <div v-if="orderList.length > 0">
                <el-collapse-item v-for="(item, key) of orderList" :key="key">
                    <template slot="title">
                        <div class="coll_img" :style="{'backgroundImage': 'url(' + item.goodsIcon + ')'}"></div>
                        <div>
                            <div class="coll_name">{{item.subOrderCount > 1 ? $t('multiName') : item.goodsName}}</div>
                            <div class="coll_time">{{formatDate(parseInt(item.createTime))}}</div>
                        </div>
                        <div class="coll_status">{{formatStatus(item.status)}}</div>
                    </template>
                    <div v-for="(i, k) of item.subOrderList" :key="k">
                        <p>{{i.goodsName}}({{i.goodsCount}}){{$t('countNum')}}</p>
                        <p>{{$t('priceLoading')}}{{i.successCount}}/{{i.totalCount}}</p>
                    </div>
                    <!-- <p>{{$t('priceLoading')}}{{formatStatus(item.status)}}</p> -->
                    <p>{{$t('orderID')}}{{item.orderId}}</p>
                    <p>{{$t('accountUID')}}{{item.uid}}</p>
                    <p>{{$t('totalAmount')}}{{allGearData.currencyList.filter(v => v.currency == item.currency)[0].currencyMark}}  {{item.totalMoney}}</p>
                    <p>{{$t('paymentChannel')}}{{item.orderType}}</p>
                    <p>{{$t('orderCreationTime')}}{{formatDate(parseInt(item.createTime))}}</p>
                    <p v-if="item.serverName">{{$t('serverName')}} {{item.serverName}}</p>
                    <p>{{$t('roleName')}} {{item.roleName}}</p>
                </el-collapse-item>
                <p v-if="orderLoad">{{$t('loading')}}</p>
                <p v-if="noMore">{{$t('noMore')}}</p>
            </div>
            <div v-else>
                <p>{{$t('noMore')}}</p>
            </div>
        </el-collapse>
      </div>
  </div>
</template>
 
<script>
import {mapActions, mapGetters} from 'vuex';
import moment from 'moment'
import qs from 'qs'
export default {
  name: 'store',
  data(){
        return {
            storage: [],
            popShow: false,
            dialogShow: false,
            totalCount: 0,
            listCount: 0,
            buyList: [],
            payment: {},
            orderList: [],
            activeTab: 0,
            currency: '',
            countryId: 0,
            loading: false,
            pageNumber: 1,
            totalPage: 0,
            orderLoad: false,
            noMore: false,
            mustInteger: 0
        }
  },
  methods:{
        ...mapActions(['serverIapList', 'getPCGear', 'getPCPayM', 'createThirdPayOrder', 'getThirdPayOrderList', 'getAllGear']),
        orderScroll(){
            this.pageNumber += 1
            if(this.totalPage > this.pageNumber){
                this.orderLoad = true
                this.getThirdPayOrderList({
                    uid: this.storage.uid,
                    accessToken: this.storage.accessToken,
                    pageNumber: this.pageNumber,
                    language: window.localStorage.getItem('language'),
                    appId: CONFIG.appId,
                    serverId: this.storage.serverId,
                    roleId: this.storage.roleId,
                    areaId: this.storage.areaId,
                })
            } else if(this.totalPage > this.pageNumber){
                this.noMore = true
            }
        },
        changePayment(item){
            if(!item.availableStatus){
                return false
            }
            this.activeTab = item.payModeId
            this.currency = item.currency
            this.countryId = item.countryId
            this.mustInteger = item.mustInteger
            this.loading = true
            this.getPCGear({
                targetCurrency: item.currency,
                countryId: item.countryId,
                appId: CONFIG.appId,
                accessToken: this.storage.accessToken
            })
            this.payment = item
        },
        dialogCtrl(tag){
            if(tag == 'record'){
                this.orderLoad = true
                this.popShow = false
                this.orderList = []
                this.pageNumber = 1
                this.getThirdPayOrderList({
                    uid: this.storage.uid,
                    accessToken: this.storage.accessToken,
                    pageNumber: 1,
                    language: window.localStorage.getItem('language'),
                    appId: CONFIG.appId,
                    serverId: this.storage.serverId,
                    roleId: this.storage.roleId,
                    areaId: this.storage.areaId,
                })
            }
        },
        backToStore(){
            this.$router.push({
                path: '/store',
                query: {
                    buyList: JSON.stringify(this.buyList)
                }
            })
        },
        popCtrl(){
            if(this.popShow){
                this.popShow = false
            } else {
                this.popShow = true
            }
        },
        pageClose(){
            window.vuplex && window.vuplex.postMessage({type: 'close', message: '关闭网页'})
        },
        payHandle(){
            if(!this.payment.currency){
                return false
            }
            let item = this.payment
            let payExtInfo = {
                ...JSON.parse(item.payExtInfo),
                country: item.country,
                language: window.localStorage.getItem('language'),
                paymentDetail: JSON.parse(item.payExtInfo)
            }
            this.createThirdPayOrder({
                payChannel: item.payChannel,
                appId: CONFIG.appId,
                goodsLists: this.buyList,
                payExtInfo: payExtInfo,
                returnUrl: window.location.origin + '/finish',
                // returnUrl: 'https://www.baidu.com',
                countryId: item.countryId,
                payModeId: item.payModeId,
                payCurrency: item.currency,
                orderOrigin: 'pc',
                cpCurrency: this.buyList[0].currency,
                accessToken: this.storage.accessToken
            })
        },
        // 支付函数 包含礼金支付
        pointPayHandle(item) {
             
        },
  },
  computed:{
    ...mapGetters(['iapInfo', 'iapLoading', 'pcgData', 'pcgLoading', 'pcPmData', 'pcPmLoading', 'orderStatus', 'orderData', 'status', 'orderLoading', 'orderInfo', 'allGearData', 'allGearLoading']),
    formatDate: (val) => {
      return (val) => {
        return moment(val).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    formatStatus: $vm => {
        return val => {
            if(val == '0'){
                return $vm.$t('toBePaid')
            } else if(val == '100'){
                return $vm.$t('tradeSuccess')
            }
        }
    }
  },
  mounted() {
        this.storage = JSON.parse(window.localStorage.getItem('storage'))
        this.buyList = JSON.parse(window.localStorage.getItem('buyList'))
        this.loading = true
        this.$watch('allGearLoading', val => {
            if(val === 'loaded'){
                this.getPCGear({
                    targetCurrency: this.currency,
                    countryId: this.storage.countryId,
                    appId: CONFIG.appId,
                    accessToken: this.storage.accessToken
                })
                
            }
        })
        this.getAllGear({
            accessToken: this.storage.accessToken,
            appId: CONFIG.appId,
            language: window.localStorage.getItem('language'),
        })
        this.$watch('orderLoading', val => {
            if(val === 'loaded'){
                this.orderInfo.list.map(val => {
                    this.orderList.push(val)
                })
                this.dialogShow = true
                this.totalPage = this.orderInfo.totalPage
                this.orderLoad = false
                this.loadShow = false
                this.loadStatus = false
                this.listLoading = false
            }
        })
        this.$watch('orderStatus', val => {
            if(val == 'stated'){
                if(this.status == 10021){
                    this.$confirm(this.$t('sureGoodsAgain'), this.$t('sureAgain'), {
                        cancelButtonText: this.$t('cancel'),
                        confirmButtonText: this.$t('sure'),
                        center: true
                    })
                    .then(() => {
                        this.serverIapList({
                            accessToken: this.storage.accessToken,
                            appId: CONFIG.appId,
                            language: window.localStorage.getItem('language')
                        })
                        let ids = this.orderData.map(v => {
                            return v.iapId
                        })
                        this.buyList = this.buyList.filter(v => !ids.includes(v.iapId))
                        this.totalCount = 0
                        this.listCount = 0
                        this.buyList.map(v => {
                            if(this.mustInteger){
                                this.totalCount += Number(Math.ceil(this.pcgData[v.price]) * 100) * v.amount
                                this.listCount += v.amount
                            } else {
                                this.totalCount += Number(this.pcgData[v.price] * 100) * v.amount
                                this.listCount += v.amount
                            }
                        })
                        window.localStorage.setItem('buyList', JSON.stringify(this.buyList))
                        this.$router.push({
                            path: '/store',
                            query: {
                                buyList: JSON.stringify(this.buyList)
                            }
                        })
                    })
                    .catch(() => {
                    });
                } else {
                    if(this.payment.payChannel == 'gash' || this.payment.payChannel == 'p99'){
                        this.payLoadShow = true
                        const tempForm = document.createElement("form")
                        tempForm.action = this.orderData.extInfo.redirectUrl
                        tempForm.target = '_self'
                        tempForm.method = 'post'
                        tempForm.style.display = 'none'
                        let opt = document.createElement("input")
                        opt.name = 'data'
                        opt.value = this.orderData.extInfo.data
                        tempForm.appendChild(opt)
                        document.body.appendChild(tempForm)
                        tempForm.submit()
                    } else {
                        window.location.href = this.orderData.extInfo.redirectUrl
                    }
                }
            }
        })
        this.$watch('pcgLoading', val => {
            if(val == 'loaded'){
                if(this.pcgData){
                    this.totalCount = 0
                    this.listCount = 0
                    this.buyList.map(v => {
                        if(this.mustInteger){
                            this.totalCount += Number(Math.ceil(this.pcgData[v.price]) * 100) * v.amount
                            this.listCount += v.amount
                        } else {
                            this.totalCount += Number(this.pcgData[v.price] * 100) * v.amount
                            this.listCount += v.amount
                        }
                    })
                    this.loading = false
                    if(!this.activeTab){
                        this.getPCPayM({
                            appId: CONFIG.appId,
                            language: window.localStorage.getItem('language'),
                            accessToken: this.storage.accessToken,
                            countryId: this.countryId || this.storage.countryId,
                            currency: this.payment.currency || this.currency,
                            goodsLists: this.buyList,
                            totalMoney: ((this.totalCount/100).toFixed(2))
                        })
                    }
                }
            }
        })
  }
}
</script>
 
<style lang="scss">
.pay{
    position: relative;
    width: 100%;
    height: 100%;
    color: #fff5d4;
    .dialog{
        .el-loading-mask{
            background: rgba(255,255,255.9);
        }
    }
    .coll_status{
        display: inline-block;
        right: 90px;
        position: absolute;
        font-size: 20px;
    }
    .el-loading-mask{
        background-color: transparent;
    }
    .el-input.is-disabled .el-input__inner{
        background-color: #462f1e;
        color: #fff;
    }
    .item_count{
        position: absolute;
        left: 240px;
        top: 145px;
        .el-input-number{
            display: inline-block;
        }
        input{
            background-color: #462f1e;
            color: #fff;
            width: 70px;
            height: 22px;
            font-size: 18px;
            line-height: 22px;
            text-align: center;
            &:focus-visible {
                outline: -webkit-focus-ring-color auto 0px;
            }
        }
        .cost{
            // background: url('../assets/plus.png') 89% 50% no-repeat;
            background-size: 26px 27px !important;
            display: inline-block;
            width: 26px;
            height: 27px;
            cursor: pointer;
            position: relative;
            top: -4px;
        }
        .plus{
            // background: url('../assets/plus.png') 89% 50% no-repeat;
            background-size: 26px 27px !important;
            display: inline-block;
            width: 26px;
            height: 27px;
            cursor: pointer;
            position: relative;
            top: -4px;
        }
    }
    .top{
        height: 90px;
        position: relative;
        display: flex;
        .top_left{
            position: relative;
            width: 300px;
            height: 90px;
            .icon{
                position: absolute;
                width: 57px;
                height: 57px;
                top: 20px;
                left: 30px;
            }
            .game_name{
                font-size: 20px;
                position: absolute;
                left: 90px;
                top: 20px;
            }
            .game_name_line{
                font-size: 28px;
                position: absolute;
                left: 90px;
                top: 45px;
            }
        }
        .top_center{
            position: relative;
            width: 872px;
            height: 90px;
            text-align: left;
            .uname{
                position: relative;
                font-size: 38px;
                line-height: 90px;
                display: inline-block;
            }
            .server_name{
                position: relative;
                font-size: 38px;
                display: inline-block;
                line-height: 90px;
            }
        }
        .pop_down_pop{
            z-index: 1;
            background-color: rgba(0,0,0,0);
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
        }
        .close{
            // background: url('../assets/close.png') 0 100% no-repeat;
            background-size: 100% auto !important;
            width: 47px;
            height: 47px;
            position: absolute;
            cursor: pointer;
            left: 330px;
            top: 28px;
        }
        .top_right{
            position: relative;
            width: 300px;
            height: 90px;
            text-align: left;
            .point_num{
                line-height: 90px;
                font-size: 28px;
                em{
                    font-size: 24px;
                    font-style: initial;
                }
            }
            .detail{
                // background: url('../assets/detail.png') 0 100% no-repeat;
                background-size: 29px 29px !important;
                width: 29px;
                height: 29px;
                position: relative;
                display: inline-block;
                top: 4px;
                left: 4px;
                cursor: pointer;
            }
            .user{
                // background: url('../assets/user.png') 0 100% no-repeat;
                background-size: 47px 47px !important;
                width: 47px;
                height: 47px;
                position: absolute;
                cursor: pointer;
                left: 260px;
                top: 28px;
            }
            .pop_down{
                // background: url('../assets/pop_down.png') 0 100% no-repeat;
                background-size: 288px 339px !important;
                width: 288px;
                height: 339px;
                position: relative;
                left: 115px;
                top: 60px;
                z-index: 9;
                .down_li{
                    position: relative;
                    margin: 0 30px;
                    top: 32px;
                    line-height: 46px;
                    border-bottom: 1px solid #473420;
                    // background: url('../assets/arrow_right.png') 100% 50% no-repeat;
                    background-size: 11px 21px !important;
                    cursor: pointer;
                    &:last-child{
                        border-bottom: 0px solid #473420;
                    }
                }
            }
        }
    }
    .content{
        position: relative;
        height: 793px;
        display: flex;
        .content_left{
            width: 300px;
            height: 73px;
            cursor: pointer;
            margin-top: 5px;
            .back_to_store{
                font-size: 26px;
                line-height: 73px;
                text-align: center;
                font-weight: bolder;
                text-shadow: 1px 1px black;
                // background: url('../assets/back_to_store.png') 0 100% no-repeat;
                background-size: 233px 69px;
                width: 233px;
                height: 69px;
                margin-left: 10px;
                margin-top: 20px;
            }
        }
        .content_center{
            overflow-y: scroll;
            margin-top: 20px;
            padding: 0 40px;
            &::-webkit-scrollbar{
                width: 0 !important;
                height: 0 !important;
                display: none;
            }
            .channel_title{
                color: #f0d386;
                font-size: 26px;
                text-align: left;
                margin-top: 40px;
            }
            .title{
                font-size: 36px;
                line-height: 36px;
                color: #f0d386;
                font-weight: bolder;
            }
            .pay_total{
                display: flex;
                justify-content: space-between;
                font-size: 28px;
                margin-top: 20px;
                color: #f0d386;
            }
            .pay_line{
                height: 1px;
                border-top: 1px solid #685c3d;
                width: 300px;
                margin-top: 20px;
            }
            .channel_box{
                display: flex;
                justify-content: left;
                flex-wrap: wrap;
                align-content: baseline;
                margin-top: 10px;
                max-height: 400px;
                overflow-y: scroll;
                &::-webkit-scrollbar{
                    width: 0 !important;
                    height: 0 !important;
                    display: none;
                }
                .channel{
                    // background: url('../assets/pay.png') 0 100% no-repeat;
                    width: 247px;
                    height: 69px;
                    display: block;
                    line-height: 69px;
                    color: #f0d386;
                    font-size: 24px;
                    font-weight: bolder;
                    cursor: pointer;
                    margin: 5px 14px 60px;
                    &:hover{
                        // background: url('../assets/pay_hover.png') 0 100% no-repeat;
                        color: #32210f;
                    }
                    &.channel_hover{
                        // background: url('../assets/pay_hover.png') 0 100% no-repeat;
                        color: #32210f;
                    }
                    &.channel_disable{
                        cursor: no-drop;
                        // background: url('../assets/pay_disable.png') 0 100% no-repeat;
                        color: #fff;
                    }
                }
            }
            .submit{
                // background: url('../assets/submit.png') 0 0 no-repeat;
                background-size: 285px 66px !important;
                width: 285px;
                height: 66px;
                font-size: 24px;
                line-height: 66px;
                color: #5d371a;
                position: fixed;
                left: 50%;
                cursor: pointer;
                margin-left: -142.5px;
                top: 750px;
                &.submit_disable{
                    filter: grayscale(100%);
                    cursor: no-drop;
                }
            }
        }
        .half_center{
            width: 872px;
        }
        .full_center{
            width: 1272px;
        }
        .content_right{
            // background: url('../assets/goods_list.png') 0 100% no-repeat;
            width:400px;
            .right_close{
                width: 24px;
                height: 67px;
                position: absolute;
                left: 1177px;
                top: 354px;
                cursor: pointer;
            }
            .clear{
                position: relative;
                right: 0;
                text-align: right;
                height: 40px;
                line-height: 40px;
                padding-right: 40px;
                cursor: pointer;
            }
            .buy_list_box{
                height: 625px;
                overflow-y: scroll;
                &::-webkit-scrollbar{
                    width: 0 !important;
                    height: 0 !important;
                    display: none;
                }
            }
            .buy_list{
                position: relative;
                border-bottom: 2px solid #473420;
                margin-left: 10px;
                .list_name{
                    font-size: 30px;
                    text-align: left;
                    text-indent: 20px;
                    font-weight: bolder;
                    line-height: 36px;
                    top: 10px;
                    position: relative;
                }
                .list_limit{
                    display: inline-block;
                    width: 100%;
                    span{
                        color: #ffecb2;
                        font-size: 16px;
                        position: relative;
                        // display: inline-block;
                        text-align: left;
                        background-color: #2e2216;
                        padding: 2px 10px;
                        margin-left: 10px;
                        top: 10px;
                        float: left;
                    }
                }
                .list_point{
                    font-size: 18px;
                    position: relative;
                    top: 20px;
                    text-align: left;
                    text-indent: 20px;
                    line-height: 36px;
                }
                .item_count{
                    position: relative;
                    top: -10px;
                    left: 100px;
                }
            }

            .total_count{
                font-size: 24px;
                line-height: 36px;
                margin-top: 20px;
            }
            .submit{
                // background: url('../assets/submit.png') 0 0 no-repeat;
                width: 190px;
                height: 44px;
                font-size: 32px;
                line-height: 44px;
                color: #5d371a;
                position: relative;
                left: 105px;
                cursor: pointer;
            }
            // background-color: #fff;
        }
    }
}
</style>